// Job properties
import PropTypes from 'prop-types';

export const ID_JOB = 'id';
export const TITLE_JOB = 'title';
export const CATEGORY_JOB = 'category';
export const TYPE_JOB = 'type';
export const REGIONAL_RESTRICTIONS_JOB = 'regionalRestrictions';
export const BENEFITS_JOB = 'benefits';
export const HOW_TO_APPLY_JOB = 'howToApply';
export const DETAILS_JOB = 'detail';
export const USER_ID_JOB = 'userId';
export const STATUS_JOB = 'status';
export const STATUS_ACTIVE = 'active';
export const STATUS_INACTIVE = 'inactive';
export const CREATION_DATE_JOB = 'createdAt';
export const UPDATE_DATE_JOB = 'updatedAt';
export const INTERNAL_CANDIDATES_ENABLED_JOB = 'internalCandidatesEnabled';

class Job {
  constructor(
    id,
    userId,
    companyId,
    title,
    category,
    type,
    detail,
    regionalRestrictions,
    benefits,
    howToApply,
    internalCandidatesEnabled,
    salaryFrom,
    salaryTo,
    priorityResult,
    createdAt,
    updatedAt
  ) {
    this.id = id;
    this.userId = userId;
    this.companyId = companyId;
    this.title = title;
    this.category = category;
    this.type = type;
    this.detail = detail;
    this.regionalRestrictions = regionalRestrictions;
    this.benefits = benefits;
    this.howToApply = howToApply;
    this.internalCandidatesEnabled = internalCandidatesEnabled;
    this.salaryFrom = salaryFrom;
    this.salaryTo = salaryTo;
    this.priorityResult = priorityResult;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export const JobPropTypes = PropTypes.shape({
  id: PropTypes.string,
  userId: PropTypes.string,
  companyId: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  type: PropTypes.string,
  detail: PropTypes.object,
  regionalRestrictions: PropTypes.string,
  benefits: PropTypes.string,
  howToApply: PropTypes.string,
  internalCandidatesEnabled: PropTypes.bool,
  salaryFrom: PropTypes.number,
  salaryTo: PropTypes.number,
  priorityResult: PropTypes.number,
  createdAt: PropTypes.number,
  updatedAt: PropTypes.number
});

// Company properties
export const ID_COMPANY = 'id';
export const USER_ID_COMPANY = 'userId';
export const URL_COMPANY = 'siteURL';
export const LOCATION_COMPANY = 'location';
export const NAME_COMPANY = 'name';
export const INVOICE_EMAIL_COMPANY = 'invoiceEmail';
export const INVOICE_ADDRESS_COMPANY = 'invoiceAddress';
export const FILE_ID_LOGO_COMPANY = 'fileIdLogo';
export const URL_LOGO_COMPANY = 'logoUrl';
export const TEMPORAL_LOGO_COMPANY = 'fileURLTemporal';
export const EMAIL_COMPANY = 'email';
export const DETAILS_COMPANY = 'detail';

class Company {
  constructor(
    id,
    userId,
    siteURL,
    location,
    name,
    invoiceEmail,
    invoiceAddress,
    fileIdLogo,
    logoUrl,
    fileURLTemporal,
    email,
    detail
  ) {
    this.id = id;
    this.userId = userId;
    this.siteURL = siteURL;
    this.location = location;
    this.name = name;
    this.invoiceEmail = invoiceEmail;
    this.invoiceAddress = invoiceAddress;
    this.fileIdLogo = fileIdLogo;
    this.logoUrl = logoUrl;
    this.fileURLTemporal = fileURLTemporal;
    this.email = email;
    this.detail = detail;
  }
}
export const CompanyPropTypes = PropTypes.shape({
  id: PropTypes.string,
  userId: PropTypes.string,
  siteURL: PropTypes.string,
  location: PropTypes.string,
  name: PropTypes.string,
  invoiceEmail: PropTypes.string,
  invoiceAddress: PropTypes.string,
  fileIdLogo: PropTypes.string,
  logoUrl: PropTypes.string,
  fileURLTemporal: PropTypes.string,
  email: PropTypes.string,
  detail: PropTypes.object
});

// File properties
export const ID_FILE = 'id';
export const USER_ID_FILE = 'userId';
export const NAME_FILE = 'name';
export const TYPE_FILE = 'type';
export const PUBLIC_URL_FILE = 'publicUrl';

class File {
  constructor(id, userId, type, publicUrl, createdAt, updatedAt) {
    this.id = id;
    this.userId = userId;
    this.type = type;
    this.publicUrl = publicUrl;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export const FilePropTypes = PropTypes.shape({
  id: PropTypes.string,
  userId: PropTypes.string,
  type: PropTypes.string,
  publicUrl: PropTypes.string,
  createdAt: PropTypes.number,
  updatedAt: PropTypes.number
});

export { Job, Company, File };
